import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "styles/index.css";

// Знаходимо головний DOM-елемент в public/index.html
const container = document.getElementById("root");
// Створюємо "корінь" React
const root = createRoot(container);

// Рендеримо головний компонент <App />
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
